import React, { Component } from "react";
import styled from "styled-components";
import { hoverEffect } from "../styles";

export class Packages extends Component {
  render() {
    return (
      <Container>
        <Header>
          <HeaderText>My Insurance Plans</HeaderText>
          <Filter>
            <FilterText>Show</FilterText>
            <FilterType>
              <Option>Today</Option>
            </FilterType>
          </Filter>
        </Header>
        <PlansContainer>
          <PlansCard>
            <CardText>RETIREMENT INSURANCE</CardText>
            <TotalText>
              Total Amount
              <CardText>#600</CardText>
            </TotalText>
          </PlansCard>
          <PlansCard>
            <CardText>CONTENT INSURANCE</CardText>
            <TotalText>
              Total Amount
              <CardText>#600</CardText>
            </TotalText>
          </PlansCard>
          <PlansCard>
            <CardText>PRODUCT LIABILTY INSURANCE</CardText>
            <TotalText>
              Total Amount
              <CardText>#600</CardText>
            </TotalText>
          </PlansCard>
          <PlansCard>
            <CardText>PRODUCT LIABILTY INSURANCE</CardText>
            <TotalText>
              Total Amount
              <CardText>#600</CardText>
            </TotalText>
          </PlansCard>
          <PlansCard></PlansCard>
        </PlansContainer>
      </Container>
    );
  }
}

const Container = styled.div`
  height: max-content;
  margin-top: 1rem;
 
`;
const Header = styled.div`
  display: flex;
  justify-content: space-between;
  width: 50vw;
  min-width: 150px;
  @media screen and (min-width: 320px) and (max-width: 768px) {
    width: 100%;
  }
`;

const HeaderText = styled.h4`
  width: 80%;
  color: #0a0b69;
`;

const Filter = styled.div`
  display: flex;
  width: max-content;
  height: 2rem;
  background-color: pink;
  border-radius: 4rem;
  padding: 0 1rem;
  margin-right: 5%;
`;

const FilterText = styled.p`
  font-size: 16px;
`;

const FilterType = styled.select`
  margin: 5px;
  border: none;
  background-color: pink;
`;

const Option = styled.option`
  color: 0a0b69;
`;

const PlansContainer = styled.div`
  height: 300px;
  width: 50vw;
  min-width: 150px;
  margin: 0.5rem 0;
  align-items: stretch;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  overflow-x: auto;
  overflow-y: hidden;

  ::-webkit-scrollbar {
    width: 10px;
    height: 5px;
  }

  ::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px grey;
    border-radius: 10px;
  }

  ::-webkit-scrollbar-thumb {
    background: #0a0b69;
    border-radius: 10px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: #0a0b69;
  }
  @media screen and (min-width: 320px) and (max-width: 768px) {
    width: 100%;
  }
`;

const PlansCard = styled.div`
  height: 100%;
  width: 200px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex-grow: 0;
  flex-shrink: 0;
  border-radius: 2rem;
  padding: 1.5rem;
  margin-left: 2rem;
  background: linear-gradient(to bottom right, #e6e4ff 0%, #e6e4ff 70%);
  color: #0a0b69;
  transition: 0.4s ease-in-out;
  &:hover {
    box-shadow: ${hoverEffect};
  }
`;

const CardText = styled.h5`
  color: 0a0b69;
  font-size: 16px;
  text-align: center;
  font-weight: 600;
`;

const TotalText = styled.h5`
  color: 0a0b69;
  text-align: center;
  font-size: 16px;
`;
export default Packages;
